import "./Header.css"; //TODO: remove this css file once whole migration is done
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Login from "@/pages/auth/login/Login";
import { useListingStore, useLoginStore, setUserAccessList } from "@/store/slices";
import { ADZONE, API_PUBLIC_HOST, CONTACT_US, MY_ADDRESS, MY_PROFILE, MY_TRANSACTION, OFFERZONE, PAYMENTSUMMARY, PROFILE_PLACEHOLDER_IMG, GENERAL_LISTING, MYPOSTINGS, SEARCH_LINK, MY_PLANS, BUYLISTING, PILLARX_LOGO, BLOG, ACCESS_TYPES, AccessTypeConstants, DEALER_LISTING, SERVICEPROVIDERLIST, DELETE_ACCOUNT } from "@/_constant";
import Loader from "../../../public/plugins/loader/loader";
import { setBuyCategoriesData, setSellCategoriesData, setServiceCategoriesData } from "@/store/reducer/categoriesListSlice/categories";
import { Button, DialogBox, DialogBoxActions } from "@/_component/Common";
import { useAuthContext, useLanguageContext, useListingLimitExceedPopupToggle, useLoginToggle } from "@/hooks";
import { copyToClipboard, swapLabel, accessTypeName } from "@/utility/common-utils";
import api from "@/apis/request";
import { Success } from "@/_service/notification/notification";
// import { SearchBar } from "@/_component/shared";
import { fetchUserAccessList } from "@/apis";
import { MY_PORTFOLIO } from "../../../../_constant/urlconstants";

function createMenu(level = 0, menus, language) {
  if (!menus || menus.length <= 0) return null;
  return menus.map(menu => {
    if (!menu.name) return null;
    const hasSubMenu = menu.sub_menus && menu.sub_menus.length > 0;

    const displayName = language(swapLabel(menu.name)) === menu.name ? menu.name : (language(swapLabel(menu.name)) || menu.name);

    if (!hasSubMenu) {
      return (
        <li className={level <= 0 ? "nav-item" : ""} key={menu.name}>
          <Link
            className={level <= 0 ? `nav-link text-nowrap d-flex align-items-center ${menu.active ? "active fw-medium text-white" : ""}` : "dropdown-item text-dark"}
            onClick={(e) => {
              if (menu.onClick) {
                e.preventDefault();
                menu.onClick(menu.type, menu.link);
              }
            }}
            to={menu.link}
            style={level <= 0 ? { fontSize: '14px', color: menu.active ? '#ffffff' : 'rgba(255,255,255,0.85)' } : { fontSize: '14px' }}
          >
            {displayName}
            {menu.badge && (
              <span className="badge rounded-pill ms-2 text-white" style={{ backgroundColor: '#f26522', fontSize: '9px', padding: '3px 6px' }}>{menu.badge}</span>
            )}
          </Link>
        </li>
      );
    }
    return (
      <li className="nav-item dropdown" id={`${menu.name.toLowerCase()}-dropdown`} key={menu.name}>
        <Link
          className="nav-link text-nowrap dropdown-toggle d-flex align-items-center"
          to="#"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          style={{ fontSize: '14px', color: 'rgba(255,255,255,0.85)' }}
        >
          {displayName}
          {menu.badge && (
            <span className="badge rounded-pill ms-2 text-white" style={{ backgroundColor: '#f26522', fontSize: '9px', padding: '3px 6px' }}>{menu.badge}</span>
          )}
        </Link>
        <ul className="dropdown-menu border-0 shadow">
          {createMenu(level + 1, menu.sub_menus, language)}
        </ul>
      </li>
    );
  });
}

export default function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selectedAccessDisplayCodeVal = sessionStorage.getItem('selectedDropAccessDisplayCode');
  const showPortfolioMenu = useMemo(() => {
    return (
      selectedAccessDisplayCodeVal === "access.dealer" ||
      selectedAccessDisplayCodeVal === "access.service_provider" ||
      selectedAccessDisplayCodeVal === "access.investor"
    );
  }, [selectedAccessDisplayCodeVal]);

  const { languageData, language, changeLanguage, languageList } = useLanguageContext();
  /*
  Not required as of now
  const sampleSuggestions = useMemo(() => {
    if (!languageData) return [];
    return Array.from(languageData.entries()).filter(([key, value]) =>
      key?.trim() !== "" &&
      value?.trim() !== "" &&
      (key.startsWith("category.") || key.startsWith("brand.group."))
    );
  }, [languageData]);
  */
  const { isAuth, user, logout } = useAuthContext();
  const { loginPopup } = useLoginStore();
  const handleLoginToggle = useLoginToggle();
  const { listingLimitExceedPopup } = useListingStore();
  const handleListingLimitExceedPopupToggle = useListingLimitExceedPopupToggle();
  const schema = {
    id: 0,
    code: "en",
    name: "english",
    display: "English",
  };
  const [disLanguage, setDisLanguage] = useState(schema);
  const [sellCategoriesList, setSellCategoriesList] = useState([]);
  const [serviceCategoriesList, setServiceCategoriesList] = useState([]);
  const [buyCategories, setBuyCategories] = useState([]);
  const [userAccessList, setHeaderUserAccessList] = useState([]);

  const handleGlobalSearch = useCallback((value) => {
    if (value !== '') {
      navigate(SEARCH_LINK + "?query=" + encodeURIComponent(value));
    }
  }, [navigate]);

  const fetchDashboardCategories = useCallback(() => {
    api.get(`${API_PUBLIC_HOST}/lookup/listCategoriesOfDashboard`)
      .then(response => {
        const data = response.data.response;
        const sellCategories = data.sell_categories || [];
        const buyCategoriesData = data.buy_categories || [];
        const serviceCategories = data.service_provider || [];

        setSellCategoriesList(sellCategories);
        setServiceCategoriesList(serviceCategories);
        setBuyCategories(buyCategoriesData);

        dispatch(setBuyCategoriesData(Object.assign([], buyCategoriesData)));
        dispatch(setServiceCategoriesData(Object.assign([], serviceCategories)));
        dispatch(setSellCategoriesData(Object.assign([], sellCategories)));
      })
      .catch(error => {
        console.error("Error fetching dashboard categories:", error);
      });
  }, [dispatch]);

  useEffect(() => {
    fetchDashboardCategories();
  }, [fetchDashboardCategories]);

  useEffect(() => {
    if (isAuth) {
      fetchUserAccessList()
        .then(res => {
          const data = res.data.response;
          setHeaderUserAccessList(data || []);
          dispatch(setUserAccessList(Object.assign([], data)));
          if (!sessionStorage.getItem('selectedDropAccessType') && data && data.length > 0) {
            const firstAccess = data[0];
            sessionStorage.setItem('selectedDrop', firstAccess.category_id);
            sessionStorage.setItem('selectedUserAccessId', firstAccess.id);
            sessionStorage.setItem('accessId', firstAccess.accessId || firstAccess.access_id);
             sessionStorage.setItem('selectedCategoryName', firstAccess.category_name);
             sessionStorage.setItem('selectedDropAccessDisplayCode', firstAccess.access_display_code);
             sessionStorage.setItem('selectedDropAccessType', accessTypeName(firstAccess.access_name || firstAccess.accessId || firstAccess.access_id));
          }
        })
        .catch(error => {
          console.error("Error fetching user access list:", error);
        });
    }
  }, [isAuth, dispatch, language]);

  const handleChangeRegistrationspage = useCallback((e) => {
    e.preventDefault();
    handleLoginToggle(false);
    navigate("/register");
  }, [handleLoginToggle, navigate]);

  const openCategorySellBuy = useCallback(async (cat, id) => {
    const categoryListMap = {
      'sell': sellCategoriesList,
      'buy': buyCategories,
      'service': serviceCategoriesList
    };
    const temp = categoryListMap[cat]?.find((item) => item.id === id);
    if (!temp) return;

    if (cat === "sell") {
      let userPlanId = temp.user_plan_id;
      if (isAuth) {
        let customerAccess = userAccessList.find(
          (access) => String(access.access_name || "").toLowerCase() === "customer"
        );
        if (!customerAccess) {
          const response = await api.post(`${API_PUBLIC_HOST}/user/createFarmerUserAccess`);
          customerAccess = response?.data?.response;
        }
        userPlanId = customerAccess?.user_plan_id || userPlanId;
      }
      const searchParams = new URLSearchParams({
        postType: "customer",
      });
      if (userPlanId) searchParams.set("userPlanId", String(userPlanId));
      navigate(`/sell/${temp.key}?${searchParams.toString()}`);
    } else if (cat === "buy") {
      navigate(`/buy/${temp.key}`);
    } else {
      navigate(`/services/${temp.key}`);
    }
  }, [sellCategoriesList, buyCategories, serviceCategoriesList, isAuth, userAccessList, navigate]);

  const menus = useMemo(() => {
    if (!sellCategoriesList || !buyCategories || !serviceCategoriesList) {
      return [];
    }
    const buyMenus = [];
    const sellMenus = [];
    const serviceMenus = [];
    buyCategories.forEach(buy => {
      if (buy.is_active) {
        buyMenus.push({
          type: "buy",
          name: buy.displayCode,
          link: buy.id,
          onClick: openCategorySellBuy,
          sub_menus: []
        });
      }
    });
    sellCategoriesList.forEach(sell => {
      if (sell.is_active) sellMenus.push(sell);
    });
    serviceCategoriesList.forEach(service => {
      if (service.is_active) {
        serviceMenus.push({
          type: "service",
          name: service.displayCode,
          link: service.id,
          onClick: openCategorySellBuy,
          sub_menus: []
        });
      }
    });
    return [
      {
        name: "label.home",
        link: "/",
        active: true,
        sub_menus: [],
      },
      {
        name: "Buy",
        link: "#",
        sub_menus: buyMenus,
      },
      {
        name: "Sell",
        link: "#",
        onClick: () => openCategorySellBuy(
          "sell",
          (sellMenus.find((category) => String(category.id) === "8") || sellMenus[0])?.id
        ),
        sub_menus: [],
      },
      {
        name: "Rentals",
        link: "/buy/property-dealers",
        sub_menus: [],
      },
      {
        name: "Services",
        link: "#",
        sub_menus: serviceMenus,
      },
      {
        name: "Offer Zone",
        link: OFFERZONE,
        sub_menus: [],
      },
      {
        name: "Ad Zone",
        link: ADZONE,
        sub_menus: [],
      },
      {
        name: "My Listing",
        link: GENERAL_LISTING,
        onClick: () => {
          const selectedAccessDisplayCode = sessionStorage.getItem('selectedDropAccessDisplayCode');
          if (selectedAccessDisplayCode === "access.dealer") {
            navigate(DEALER_LISTING);
          } else if (selectedAccessDisplayCode === "access.service_provider") {
            navigate(SERVICEPROVIDERLIST);
          } else {
            navigate(GENERAL_LISTING);
          }
        },
        sub_menus: [],
      },
      {
        name: "Payment Summary",
        link: PAYMENTSUMMARY,
        sub_menus: [],
      },
      {
        name: "My Postings",
        link: MYPOSTINGS,
        sub_menus: [],
      },
      {
        name: "label.blog",
        label: "Blog",
        link: BLOG,
        sub_menus: [],
      }
    ];
  }, [sellCategoriesList, buyCategories, serviceCategoriesList, openCategorySellBuy]);

   const handleLanguageChange = (e) => {
    e.preventDefault();
    const languageName = e.target.getAttribute('data-lang');
    const item = languageList.find(obj => obj.name === languageName);
    setDisLanguage(item);
    changeLanguage(item.name);
    localStorage.setItem('language', JSON.stringify(item));
  };

  return (
    <>
      <header className="shadow-sm" style={{ backgroundColor: '#4b2b64', fontFamily: "'Inter', system-ui, sans-serif" }}>
        <div className="py-2">
          <div className="container" style={{ maxWidth: '1280px' }}>
            <div className="d-flex justify-content-between align-items-center gap-4">
              <div className="logo-container me-lg-3 d-flex align-items-center">
                <button className="navbar-toggler text-white border-0 outline-0 d-lg-none me-2" type="button" data-bs-toggle="offcanvas" data-bs-target="#kgNavbar" aria-controls="kgNavbar" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="bi bi-list fs-1"></span>
                </button>
                <a className="navbar-brand text-white d-flex align-items-center text-decoration-none" href="/">
                  <img src={PILLARX_LOGO} alt="PillarX" style={{ height: '40px', width: 'auto' }} />
                </a>
              </div>
              {/* <div className="flex-fill d-none d-lg-block opacity-0 pe-none">
                <SearchBar suggestions={sampleSuggestions} onSearch={handleGlobalSearch} />
              </div> */}
              <div>
                <div className="d-flex justify-content-end align-items-center flex-nowrap py-2 w-100">
                  <div className="text-decoration-none d-none d-md-block">
                    <div onClick={async () => {
                      const category = sellCategoriesList.find((item) => String(item.id) === "8") || sellCategoriesList[0];
                      if (!category) return;
                      let customerAccess = userAccessList.find(
                        (access) => String(access.access_name || "").toLowerCase() === "customer"
                      );
                      if (!customerAccess && isAuth) {
                        const response = await api.post(`${API_PUBLIC_HOST}/user/createFarmerUserAccess`);
                        customerAccess = response?.data?.response;
                      }
                      const search = new URLSearchParams({
                        postType: "customer",
                        mode: "offline",
                      });
                      if (customerAccess?.user_plan_id) {
                        search.set("userPlanId", String(customerAccess.user_plan_id));
                      }
                      navigate(`/sell/${category.key}?${search.toString()}`);
                    }} className="bg-white rounded-pill d-flex align-items-center p-1 pe-3 cursor-pointer me-3 shadow-sm" style={{ height: '42px' }}>
                      <div className="rounded-circle d-flex align-items-center justify-content-center me-2 border border-2 border-primary border-opacity-25" style={{ width: '34px', height: '34px', backgroundColor: '#f8f9fa' }}>
                        <i className="bi bi-house-check-fill" style={{ fontSize: '16px', color: '#665287' }}></i>
                      </div>
                      <div className="d-flex flex-column justify-content-center lh-1">
                        <div className="d-flex align-items-center">
                          <span className="fw-bold text-dark me-2" style={{ fontSize: '12px' }}>Sell With Expert Support</span>
                          <span className="badge rounded-pill text-white" style={{ backgroundColor: '#ff6b00', fontSize: '9px', padding: '2px 6px' }}>FREE</span>
                        </div>
                        <span className="text-muted mt-1" style={{ fontSize: '10px' }}>Private Sale &bull; Offline listing</span>
                      </div>
                      <i className="bi bi-chevron-right text-dark ms-3 fw-bold" style={{ fontSize: '14px' }}></i>
                    </div>
                  </div>
                  
                  <div className="dropdown kg-bg-white fs-7 py-2 px-4 rounded-pill cursor-pointer mx-2" role="listbox">
                      <div className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        <span className="me-1 text-uppercase">{disLanguage?.display}</span>
                      </div>
                      <ul className="dropdown-menu" onClick={handleLanguageChange}>
                        {languageList.map(language => <li className="dropdown-item" data-lang={language.name} key={language.id}>{language?.display} - {language?.name}</li>)}
                      </ul>
                    </div>

                  <div className="notification position-relative d-flex align-items-center justify-content-center rounded-circle cursor-pointer me-3" style={{ backgroundColor: 'rgba(255,255,255,0.15)', width: '40px', height: '40px' }}>
                    <i className="bi bi-bell text-white" style={{ fontSize: '18px' }}></i>
                    <span className="position-absolute badge rounded-circle d-flex align-items-center justify-content-center" style={{ backgroundColor: '#ff6b00', fontSize: '10px', width: '16px', height: '16px', top: '0px', right: '0px', padding: 0 }}>2</span>
                  </div>

                  <div className="dropdown">
                    {!isAuth ? (
                      <div className="d-flex align-items-center rounded-pill p-1 pe-3 cursor-pointer" style={{ backgroundColor: 'rgba(255,255,255,0.15)', height: '40px' }} id="loginregisterdiv" onClick={handleLoginToggle}>
                        <div className="bg-white rounded-circle d-flex align-items-center justify-content-center me-2" style={{ width: '32px', height: '32px' }}>
                          <i className="bi bi-person text-dark" style={{ fontSize: '18px' }}></i>
                        </div>
                        <span className="text-white fw-medium d-none d-md-block" style={{ fontSize: '14px' }}>Login/Signup</span>
                      </div>
                    ) : (
                      <a href="#profile-dropdown" className="d-flex align-items-center rounded-pill p-1 pe-3 cursor-pointer text-decoration-none" data-bs-toggle="dropdown" aria-expanded="false" style={{ backgroundColor: 'rgba(255,255,255,0.15)', height: '40px' }}>
                        <img src={user?.profileUrl ?? PROFILE_PLACEHOLDER_IMG} alt="profile" width="32" height="32" className="rounded-circle me-2 bg-white" />
                        <span className="text-white fw-medium text-uppercase text-truncate d-none d-md-block" style={{ maxWidth: '100px', fontSize: '14px' }}>{user?.name}</span>
                      </a>
                    )}
                    <ul className="dropdown-menu dropdown-menu-end text-small" id="profile-dropdown">
                      <li>
                        <div className="px-3">
                          <div className="text-bold">{user?.name}</div>
                          <div>{user?.phoneNumber}</div>
                        </div>
                      </li>
                      <li><hr className="dropdown-divider" /></li>
                      <li>
                        <div className="user-select-all px-3 d-inline-flex align-items-center">
                          <span className="me-2" onClick={() => copyToClipboard(user?.referralCode).then(Success("Copied!"))}>{user?.referralCode}</span>
                          <Button noSpacing onClick={() => copyToClipboard(user?.referralCode).then(Success("Copied!"))}><i className="bi bi-copy"></i></Button>
                        </div>
                      </li>
                      <li><hr className="dropdown-divider" /></li>
                      <li><Link className="dropdown-item" to={MY_PROFILE}><i className="bi bi-person pe-2"></i>Profile</Link></li>
                      {showPortfolioMenu && (
                        <li><Link className="dropdown-item" to={MY_PORTFOLIO}><i className="bi bi-person pe-2"></i>My Portfolio</Link></li>
                      )}
                      <li><hr className="dropdown-divider" /></li>
                      <li><Link className="dropdown-item" to={MY_PLANS}><i className="bi bi-list-task pe-2"></i>My Plans</Link></li>
                      <li><Link className="dropdown-item" to={MY_TRANSACTION}><i className="bi bi-credit-card pe-2"></i>My Transactions</Link></li>
                      <li><Link className="dropdown-item" to={MY_ADDRESS}><i className="bi bi-geo-alt pe-2"></i>My Address</Link></li>
                      <li><Link className="dropdown-item" to={CONTACT_US}><i className="bi bi-question-circle pe-2"></i>Support</Link></li>
                      <li><Link className="dropdown-item" to={DELETE_ACCOUNT}><i className="bi bi-trash pe-2"></i>Delete Account</Link></li>
                      <li><hr className="dropdown-divider" /></li>
                      <li className="text-center"><Button onClick={logout} noSpacing className="py-2 text-bold">Log out</Button></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <nav className="navbar navbar-expand-lg px-sm-3 py-1">
          <div className="container" style={{ maxWidth: '1280px' }}>
            <div className="navigation-container flex-grow-1 d-flex flex-column">
              <div className="d-flex align-items-center mt-lg-1 w-100">
                <div className="offcanvas offcanvas-end" id="kgNavbar" style={{ backgroundColor: 'var(--kg-green)' }}>
                  <div className="offcanvas-header border-bottom border-light border-opacity-25">
                    <h5 className="offcanvas-title text-white" id="kgNavbar" style={{ fontSize: '18px', fontWeight: '600' }}>
                      <img src={PILLARX_LOGO} alt="PillarX" style={{ height: '32px', width: 'auto' }} />
                    </h5>
                    <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas" data-bs-target="#kgNavbar" aria-label="Close"></button>
                  </div>
                  <div className="offcanvas-body d-flex flex-column flex-lg-row justify-content-between align-items-lg-center">
                    <ul className="navbar-nav gap-3">
                      {createMenu(0, menus, language)}
                    </ul>
                    <div className="mt-3 mt-lg-0 d-none d-lg-block">
                      <Link to={CONTACT_US} className="btn text-white rounded-pill px-4 py-2 d-flex align-items-center shadow-sm border-none" style={{ fontWeight: '500', fontSize: '14px' }}>
                        <i className="bi bi-headset me-2" style={{ fontSize: '18px' }}></i>
                        Contact us
                      </Link>
                    </div>
                  </div>
                  <div className="offcanvas-footer sticky-bottom">
                    <div className="px-4 py-2 border-top d-block d-lg-none">
                      <div className="d-flex justify-content-between align-items-center fs-4">
                        <i className="bi bi-telephone"></i>
                        <i className="bi bi-cloud-arrow-down"></i>
                        <i className="bi bi-share"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {loginPopup && (
        <Login
          handleChangeRegistrationspage={handleChangeRegistrationspage}
          show={loginPopup ? "show" : "hide"}
        ></Login>
      )}
      {listingLimitExceedPopup && <DialogBox title={"Buy/Upgrade Listings"} onClose={() => handleListingLimitExceedPopupToggle(false)}>
        <div>
          <p>Your listings limit has been exceeded. To continue.</p>
        </div>
        <DialogBoxActions>
          <Button primary outline rounded onClick={() => { handleListingLimitExceedPopupToggle(false); navigate(MY_PLANS); }}>Upgrade Plan</Button>
          <Button primary outline rounded onClick={() => { handleListingLimitExceedPopupToggle(false); navigate(BUYLISTING); }}>Buy Listing</Button>
        </DialogBoxActions>
      </DialogBox>}
      <Loader />
    </>
  );
}
